/* Reuse existing dataLayer + DOM event pattern; no new pixel or ecommerce event. */
(() => {
  if (window.btBrandAuthorityBound) return;
  window.btBrandAuthorityBound = true;
  const seen = new WeakSet();
  function allowed() { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
  function emit(event, channel) {
    if (!allowed()) return false;
    const payload = { event, bt_channel: channel || 'trajectory', bt_page_type: document.body.dataset.btPageType || 'website' };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(event, { detail: payload }));
    return true;
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting && !seen.has(entry.target) && emit(entry.target.hasAttribute('data-bt-trajectory') ? 'bt_trajectory_view' : 'bt_trust_section_view', entry.target.dataset.btTrustView)) { seen.add(entry.target); observer.unobserve(entry.target); }
  }), { threshold: 0.2 });
  const scan = () => document.querySelectorAll('[data-bt-trust-view]').forEach(el => { if (!seen.has(el)) { observer.unobserve(el); observer.observe(el); } });
  document.addEventListener('click', e => { const link = e.target.closest('[data-bt-trust-click]'); if (link) emit(link.dataset.btTrustClick, link.dataset.btChannel); });
  document.addEventListener('visitorConsentCollected', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
